import React from 'react';
import { bool,func, string, instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

class ExpanderBase extends React.PureComponent {
	static propTypes = {
		isOpen : bool,
		renderAtClosed : func,
		renderAtExpanded : func,
		cookieId : string,
		cookies : instanceOf(Cookies).isRequired
	}
	constructor(props){
		super(props);
		const { cookies,cookieId } = props;
		let isOpen = false;
		if(cookieId){
			isOpen = cookies.get(cookieId);
		}
		this.state = {
			isOpen : isOpen && isOpen === 'true'
		};
	}
	render(){
		const {renderAtClosed,renderAtExpanded,cookies,cookieId} = this.props;
		if(this.state.isOpen)
		{
			const onClick = ()=>{
				this.setState({isOpen:false});
				if(cookieId){
					cookies.set(cookieId, false);
				}
			};
			return renderAtExpanded({onClick});
		}
		const onClick = ()=>{
			this.setState({isOpen:true});
			if(cookieId){
				cookies.set(cookieId, true);
			}
		};
		return renderAtClosed({onClick});
	}
}

export default withCookies(ExpanderBase);